import { render, staticRenderFns } from "./RepeatVisitorsReport.vue?vue&type=template&id=21990414&scoped=true"
import script from "./RepeatVisitorsReport.vue?vue&type=script&lang=js"
export * from "./RepeatVisitorsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21990414",
  null
  
)

export default component.exports